import { localize, localizeWithValues } from '@/core/gambits';
import { computed, ref } from 'vue';

export function shouldConfirmLeaveGambit(gambit: { isConfirmed?: boolean | null }): boolean {
  return gambit.isConfirmed === true;
}

export function getLeaveGambitConfirmTitle(gambit: {
  title?: string | null;
  location?: { name?: string | null } | null;
}): string {
  const name =
    gambit.title?.trim() || gambit.location?.name?.trim() || localize('gambit.actions.leaveConfirmation.fallback');
  return localizeWithValues('gambit.actions.leaveConfirmation', [name]);
}

export function useLeaveGambitConfirm() {
  const pendingTitle = ref<string | null>(null);
  let pendingLeave: (() => Promise<void>) | null = null;

  const isLeaveConfirmOpen = computed(() => pendingTitle.value !== null);
  const leaveConfirmTitle = computed(() => pendingTitle.value ?? '');

  async function requestLeaveGambit(
    gambit: {
      isConfirmed?: boolean | null;
      title?: string | null;
      location?: { name?: string | null } | null;
    },
    leave: () => Promise<void>,
  ) {
    if (!shouldConfirmLeaveGambit(gambit)) {
      await leave();
      return;
    }

    pendingLeave = leave;
    pendingTitle.value = getLeaveGambitConfirmTitle(gambit);
  }

  function dismissLeaveConfirm() {
    pendingLeave = null;
    pendingTitle.value = null;
  }

  async function confirmLeaveGambit() {
    const leave = pendingLeave;
    dismissLeaveConfirm();
    if (leave) {
      await leave();
    }
  }

  return {
    isLeaveConfirmOpen,
    leaveConfirmTitle,
    requestLeaveGambit,
    dismissLeaveConfirm,
    confirmLeaveGambit,
  };
}
